module.exports = __webpack_public_path__ + "static/media/read.49136eec.svg";